module.exports = __webpack_public_path__ + "static/media/slide-3.d46ec481.png";